/** @format */

import { axiosCalls } from '../../../config/AxiosCall';

const url = 'Constants';

export async function fetchAllConstants() {
  return axiosCalls.get(`${url}/all-constants`);
}
